import React from "react"

export const LoadTypesActivityFeed = ({
  data,
}: {
  data: { value?: string[] }
}) => {
  return <b>{!data || !data.value?.length ? "empty" : data.value.join(", ")}</b>
}
